module.exports = __webpack_public_path__ + "img/collaboration-invitation.7453804a.png";